import { LngLat } from 'mapbox-gl';

// coordinates 0,0 are in the ocean, I say is not a valid lnglat
export const lngLatIsValid = (lngLat: LngLat): boolean => {
  return !(lngLat.lng === 0 && lngLat.lat === 0);
};
